module.exports = __webpack_public_path__ + "static/img/collection4.658ea388.png";